module.exports = __webpack_public_path__ + "static/media/wishlist.fe5bebd4.svg";